import React from 'react';
import * as RadixMenu from '@radix-ui/react-dropdown-menu';

import { CheckboxItem } from './DropdownMenu';
import {
  DescriptiveOptionLabel,
  DescriptiveOptionDescription,
} from '../../dropdowns/StyledDropdown';

import styles from './auxiliary.components.module.scss';
export const DescriptiveOption: React.FC<
  CheckboxItem & { description?: string; width?: number; disabled?: boolean; tag?: string }
> = ({ isChecked, title, description, onCheckedChange, width, disabled, tag }) => {
  return (
    <RadixMenu.CheckboxItem
      className={styles['list-item']}
      data-checked={isChecked}
      data-disabled={disabled}
      onCheckedChange={onCheckedChange}
      style={
        width !== undefined
          ? ({ '--list-item-width': `${width}px` } as React.CSSProperties)
          : undefined
      }
    >
      <div className={styles['left']}>
        <DescriptiveOptionLabel>{title}</DescriptiveOptionLabel>
        <DescriptiveOptionDescription>{description} </DescriptiveOptionDescription>
      </div>

      {tag && <div className={styles['tag']}>{tag}</div>}
    </RadixMenu.CheckboxItem>
  );
};
